<template>
    <div class="component site-footer section fp-auto-height">
        <div class="wrapper wrapper-large">
            <div class="container-logo">
                <img class="logo" src="../../assets/svg/logo/dt-logo.svg" alt="Telekom Logo" />
                <div class="claim">Life is for sharing.</div>
            </div>
        </div>
        <div class="wrapper wrapper-medium">
            <div class="container-legal">
                <div class="legal-notice">&copy; {{ currentYear }} Deutsche Telekom AG</div>
                <nav class="legal-menu">
                    <router-link to="/">Home</router-link>
                    <router-link to="/disclaimer">Disclaimer</router-link>
                    <router-link to="/imprint">Imprint</router-link>
                    <router-link to="/privacy-policy">Privacy</router-link>
                    <!--<a href="#" @click.prevent="openCookieConfigurator">Cookie Configurator</a>-->
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SiteFooter',
        data: function() {
            return {
                currentYear: '',
            };
        },
        mounted() {
            this.currentYear = new Date().getFullYear();
        },
        methods: {
            openCookieConfigurator() {
                this.$store.dispatch('toggleCookieConfiguratorModal');
            },
        },
    };
</script>

<style scoped lang="scss">
    .site-footer {
        color: #ffffff;
        background: color('dark-grey');
        padding: spacing(7) 0 spacing(6) 0;
        font-size: 15px;
        font-weight: font-weight('thin');

        @media (max-width: breakpoint('medium')) {
            text-align: center;
        }

        .container-logo {
            padding-bottom: spacing(7);
            border-bottom: 1px solid #999;
            margin-bottom: spacing(6);
            @include flex($justify-content: center, $align-items: center);

            @media (max-width: breakpoint('small')) {
                display: block;
            }

            .logo {
                @include reset-img();
                // width: 80px;
                width: auto;
                height: 38px;

                @media (max-width: breakpoint('small')) {
                    margin: 0 auto;
                }
            }

            .claim {
                font-size: 15px;
                font-weight: font-weight('extra-bold');
                letter-spacing: 0.05em;
                text-transform: uppercase;
                margin-left: spacing(6);
                transform: translateY(3px);

                @media (max-width: breakpoint('small')) {
                    margin-top: spacing(4);
                    margin-left: 0;
                    transform: translateY(0px);
                }
            }
        }

        .container-legal {
            @include flex($justify-content: space-between);
            margin: 0 auto;

            @media (max-width: breakpoint('medium')) {
                display: block;
            }
        }

        .legal-menu {
            a {
                color: #ffffff;
                display: inline-block;

                &:not(:last-of-type) {
                    margin-right: spacing(5);

                    @media (max-width: breakpoint('medium')) {
                        margin-right: spacing(3);
                    }
                }
            }

            @media (max-width: breakpoint('medium')) {
                margin-top: spacing(2);
            }
        }
    }
</style>
